import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface, ClientRelation, ClientType } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface AddParticipantUseCaseParams {
    client: ClientInterface;
}

@Injectable()
export class AddParticipantUseCase implements UseCaseWithParam<AddParticipantUseCaseParams, Observable<Transaction<void>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(params: AddParticipantUseCaseParams): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (contract) => {
                        if (params.client.relation === ClientRelation.HOLDER) {
                            contract.addHolder(params.client);
                        } else {
                            if (contract.holders.length > 0 && contract.holders[0].type === ClientType.LEGAL_PERSON) {
                                contract.holders[0].addLegalGuardian(params.client);
                            } else {
                                contract.addAuthorized(params.client);
                            }
                        }

                        return Transaction.success();
                    },
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
